export default __webpack_public_path__ + "static/media/background.88376feb.jpg";